const checkIsProduction = () => process.env.GATSBY_BUILD_MODE === 'production'

module.exports = checkIsProduction
